import { render, staticRenderFns } from "./addoil.vue?vue&type=template&id=2a1076c0&scoped=true&"
import script from "./addoil.vue?vue&type=script&lang=js&"
export * from "./addoil.vue?vue&type=script&lang=js&"
import style0 from "./addoil.vue?vue&type=style&index=0&id=2a1076c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1076c0",
  null
  
)

export default component.exports